/*
 * "Who's this for?" - for GUESTS, inside the site's own "Added to cart" card, on rider items with a size (riding boots and
 * other footwear, hats, jodhpurs / breeches / tights, gloves, tops) - 2 Oct 2026. The rider version of
 * assets/jhr-horse-save.js. Aaron: "one or two clicks maximum ... 'Is this for you or for someone else?' ... if they
 * select 'It's for me', the system should know ... automatically with one click."
 *
 *   [For Me]  -> one click: the size is kept as THEIR size (browser only), and from then on assets/jhr-usual-size.js
 *                picks it by itself on that kind of item, tagged "Your Size".
 *   [Someone Else] -> one more click: [An Adult] or [A Child]. Kept as "Their Size" / "Your Child's Size" and shown as
 *                a tag in the size list next time - not picked by itself (next time it may be for them).
 *   Children's items: the first button is [For My Child] (their child's size is picked by itself on children's items);
 *                "Someone Else" then offers [An Adult] or [Another Child].
 *   "No Thanks" = not asked again about that kind of item for 30 days.
 *
 * Everything stays in the shopper's own browser (localStorage "jhr_sizes"); nothing is sent to us. Signed-in customers
 * never see this - their sizes come from their account (orders, the thank-you question, My Horses & Sizes).
 * Data: the product page's <script data-jhr-rider> (snippets/jhr-usual-size.liquid): the kind, whether it is a
 * children's item, and every variant's size.
 */
(function () {
  'use strict';
  var el = document.querySelector('script[data-jhr-rider]');
  if (!el || window.jhrRiderSave) return;
  window.jhrRiderSave = true;
  var data;
  try { data = JSON.parse(el.textContent); } catch (e) { return; }
  var KEY = 'jhr_sizes';
  var family = data.child ? 'child' : 'adult';
  // a saved size counts here only if it came from the same kind of item (children's / adult); older notes have no "from"
  function sameFamily(o, slot) { var f = o.from && o.from[slot + '.' + data.kind]; return !f || f === family; }
  var DAY = 864e5;

  function read() {
    try {
      var o = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      if (o && o.v === 1) { ['me', 'adult', 'child', 'declined', 'from'].forEach(function (k) { o[k] = o[k] || {}; }); return o; }
    } catch (e) { /* storage blocked: behave as empty */ }
    return { v: 1, me: {}, adult: {}, child: {}, declined: {}, from: {} };
  }
  function write(o) {
    try { window.localStorage.setItem(KEY, JSON.stringify(o)); return true; } catch (e) { return false; }
  }
  // The same light matching as assets/jhr-usual-size.js (keep the two in step): "UK 5" = "5", "Adults Medium" = "M",
  // a children's size never equals an adult one.
  function norm(s, kind) {
    var t = String(s || '').toLowerCase().replace(/["”″]/g, '').replace(/½/g, '.5');
    // 2 Oct 2026: boots written with both sizes keep the UK one - "38EU/5UK" = "UK5" = "Adults 5" = "5", and
    // "33EU/1 Childs UK" = "Childs 1". A calf fit stays part of the size ("38EU/5UK Wide" is only ever "5 Wide").
    if (/\d\s*eu\b|\beu\s*\d/.test(t) && /\buk\b|\duk\b/.test(t)) {
      var eu = t.match(/(\d{2})(?:\.5)?\s*eu\b|\beu\s*(\d{2})/);
      var euN = eu ? +(eu[1] || eu[2]) : 0;
      t = t.replace(/\d{2}(?:\.5)?\s*eu\b|\beu\s*\d{2}(?:\.5)?/g, ' ').replace(/[\/()]/g, ' ');
      // on boots the EU number says which scale: EU 34 and under is a child's size even unlabelled ("28EU/10UK" is a
      // child's 10, not a man's), EU 23 and under a toddler's ("22EU/5UK Childs" is not the junior "38EU/5UK Childs").
      // Not on clothing - "UK 6 (EU34)" is a ladies' 6.
      if (kind === 'feet' && euN && euN <= 23) t += ' toddler';
      else if (kind === 'feet' && euN && euN <= 34) t += ' child';
    }
    // "5UK" / "UK5" = "5"; a range stays a range ("UK3-7" is 3 to 7, not 37)
    t = t.replace(/(\d)\s*uk\b/g, '$1 ').replace(/\buk\s*(?=\d)/g, ' ').replace(/(\d)\s*-\s*(\d)/g, '$1to$2');
    t = t.replace(/\b(uk|size|adults?|ladies|womens?|mens?)\b/g, ' ');
    var child = /\b(child(ren)?'?s?|kids?|junior|youth)\b/.test(t);
    var toddler = /\btoddlers?\b/.test(t);
    t = t.replace(/\b(child(ren)?'?s?|kids?|junior|youth|toddlers?)\b/g, ' ').replace(/\s+/g, ' ').trim();
    t = t.replace(/^(extra|x)[- ]?small$/, 'xs').replace(/^small$/, 's').replace(/^medium$/, 'm').replace(/^large$/, 'l')
      .replace(/^(extra|x)[- ]?large$/, 'xl').replace(/^(xx|2x)[- ]?large$/, 'xxl').replace(/[\s-]/g, '');
    if (toddler && !(parseFloat(t) <= 6)) { toddler = false; child = true; }   // toddler 7+ = child 7+ (no junior 7)
    return (toddler ? 't:' : child ? 'c:' : '') + t;
  }
  function text(tag, cls, value) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (value != null) n.textContent = value;
    return n;
  }
  function button(label, cls, onClick) {
    var b = text('button', 'jhr-rs__btn' + (cls ? ' ' + cls : ''), label);
    b.type = 'button';
    b.addEventListener('click', onClick);
    return b;
  }

  // The newest Added-to-cart card, once it has drawn its body (it builds itself as it is added to the page).
  function whenCard(done) {
    var tries = 0;
    (function look() {
      var cards = document.querySelectorAll('added-notification.jhr-anv2:not(.added-notification--dismissed)');
      var card = cards[cards.length - 1];
      var body = card && card.querySelector('.jhr-an__body');
      if (body) { done(card, body); return; }
      if (++tries < 40) window.setTimeout(look, 75);          // up to 3 s
    })();
  }

  function ask(card, body, size) {
    if (card.querySelector('.jhr-hs')) return;
    var panel = text('div', 'jhr-hs jhr-rs');
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-label', 'Save this size');
    body.insertAdjacentElement('afterend', panel);

    // No reading against the clock: the card's countdown waits until they answer (as on the horse question - the card
    // re-adds "jhr-an--counting" on its own schedule, so the pause goes back on every time).
    // 2 Oct 2026 (Aaron: the card first stayed open forever, then its countdown "about halfway through it resets
    // itself"): no pausing and restarting here. The card counts down once - for longer while this question is unanswered
    // (added-notification.js AUTO_DISMISS_QUESTION) - and closes if nobody answers. If it was already counting when the
    // question arrived, it restarts now, straight away, so the ring simply begins. A touch keeps it open (the card's own
    // phone rule); an answer restarts it at the normal length so "Saved" is seen.
    if (card.classList.contains('jhr-an--counting') && !card.classList.contains('jhr-an--paused') && typeof card._start === 'function') {
      card._start();
    }
    var resume = function () {
      if (typeof card._start === 'function') card._start();
    };

    function save(slot) {
      var o = read();
      o[slot][data.kind] = size;
      // children's and adult sizes are both often just Small / Medium / Large: remember which kind of item it came from,
      // so an adult's Large is never shown on a children's item (or the other way round) - 2 Oct live re-test
      o.from[slot + '.' + data.kind] = family;
      delete o.declined[data.kind];
      var ok = write(o);
      var msg = !ok ? 'Sorry - this browser would not let us save it.'
        : slot === 'me' ? '✓ Saved. Next time we\'ll choose ' + size + ' for you.'
        : slot === 'child' ? '✓ Saved as your child\'s size. We\'ll show ' + size + ' next time.'
        : '✓ Saved. We\'ll show ' + size + ' as their size next time.';
      panel.classList.add('jhr-hs--done');
      panel.innerHTML = '';
      panel.appendChild(text('p', 'jhr-hs__t', msg));
      resume();
    }
    function no() {
      var o = read();
      o.declined[data.kind] = Date.now();
      write(o);
      panel.remove();
      resume();
    }
    function step(q, buttons) {
      panel.innerHTML = '';
      panel.appendChild(text('p', 'jhr-hs__q', q));
      var line = text('p', 'jhr-hs__t');
      line.appendChild(document.createTextNode('We\'ll remember size '));
      line.appendChild(text('b', null, size));
      line.appendChild(document.createTextNode(' so it\'s ready next time.'));
      panel.appendChild(line);
      var row = text('div', 'jhr-rs__row');
      buttons.forEach(function (b) { row.appendChild(b); });
      panel.appendChild(row);
      var skip = text('button', 'jhr-hs__no', 'No Thanks');   // the horse question's quiet link, not a big button
      skip.type = 'button';
      skip.addEventListener('click', no);
      panel.appendChild(skip);
      row.firstChild.focus({ preventScroll: true });
    }
    function someoneElse() {
      step('Who are they?', [
        button('An Adult', 'jhr-rs__btn--main', function () { save('adult'); }),
        button(data.child ? 'Another Child' : 'A Child', 'jhr-rs__btn--main', function () { save('child'); }),
      ]);
    }
    step('Who\'s this for?', [
      data.child ? button('For My Child', 'jhr-rs__btn--main', function () { save('child'); })
        : button('For Me', 'jhr-rs__btn--main', function () { save('me'); }),
      button('Someone Else', '', someoneElse),
    ]);
  }

  document.addEventListener('on:cart:add', function (evt) {
    var id = evt && evt.detail && evt.detail.variantId;
    var v = id != null ? data.variants[String(id)] : null;
    var size = v && v[0];
    // 3 Oct 2026 (Aaron: "it seems to be asking for a one size option"): a one-size item has no size to remember
    if (!size || /\bone[\s-]?size\b|\bonesize\b|^\s*(o\/s|os|universal)\s*$/i.test(size)) return;   // not 'Universal 4/5' (SSG gloves' real sizes)
    var o = read();
    var n = norm(size, data.kind);
    // Already saved for anyone (them, an adult, a child): nothing to ask.
    if (['me', 'adult', 'child'].some(function (slot) { return sameFamily(o, slot) && o[slot][data.kind] && norm(o[slot][data.kind], data.kind) === n; })) return;
    var said = o.declined[data.kind];
    if (said && Date.now() - said < 30 * DAY) return;                          // "No Thanks" lately
    whenCard(function (card, body) { ask(card, body, size); });
  });
})();
